import { render, staticRenderFns } from "./unionGoodsImport.vue?vue&type=template&id=40fd2dd0&scoped=true&"
import script from "./unionGoodsImport.vue?vue&type=script&lang=js&"
export * from "./unionGoodsImport.vue?vue&type=script&lang=js&"
import style0 from "./unionGoodsImport.vue?vue&type=style&index=0&id=40fd2dd0&lang=less&scoped=true&"
import style1 from "./unionGoodsImport.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fd2dd0",
  null
  
)

component.options.__file = "unionGoodsImport.vue"
export default component.exports